export default "__VITE_ASSET__DFp2ew8m__"